export default __webpack_public_path__ + "static/PEUGEOT 307-70b3fdeaaf0a15e4e8f25dd2e82b8847.jpg";